// src/frontend/src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

// Optional: Initialize Sentry for error tracking in production
// import * as Sentry from "@sentry/react";
// if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_SENTRY_DSN) {
//   Sentry.init({
//     dsn: process.env.REACT_APP_SENTRY_DSN,
//     integrations: [
//       new Sentry.BrowserTracing(),
//     ],
//     tracesSampleRate: 0.1,
//     environment: process.env.NODE_ENV,
//   });
// }

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Optional: Log web vitals to analytics in production
// if (process.env.NODE_ENV === 'production') {
//   reportWebVitals((metric) => {
//     // Send to analytics
//     // Example: Google Analytics
//     // window.gtag('event', metric.name, {
//     //   value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
//     //   metric_id: metric.id,
//     //   metric_value: metric.value,
//     //   metric_delta: metric.delta,
//     // });
//   });
// }
